import { useLocation } from "react-router-dom";

import { usePlaylistContext } from "../../context/PlaylistContext";
import { BulkModeCTAStyle, BulkModeWrapperStyle } from "./BulkModeCTA.style";

const BulkModeCTA = () => {
  const { state, dispatch } = usePlaylistContext();

  const location = useLocation();

  const handleChange = (e) => {
    localStorage.setItem("bulk", JSON.stringify(e, null, " "));
    dispatch({
      type: "TOGGLE_BULK_MODE",
      payload: e,
    });
  };

  const isDisabled = location.pathname.includes("search") && !state.isBulkMode;
  return (
    <BulkModeWrapperStyle>
      <BulkModeCTAStyle
        checked={state.isBulkMode}
        disabled={isDisabled}
        onChange={handleChange}
      />
      Bulk mode
    </BulkModeWrapperStyle>
  );
};

export default BulkModeCTA;
